class Dadata {
    constructor() {
        this.api_keys = [
            'bd7ceeb343835e6d70e20081f93448a74d66de74', // vikonstore@yandex.ru
            'd647cb45dc70bae281d5062919853b0a1ccdf9b9', // vikonstore3@yandex.ru
            'de927eca3fa35fac1d086c82fecc6e78141ddbe9', // vikondata1@mail.ru
            'bd7c491f3ae21bb38dcf16bfc5dde1e0714756a9', // vikondata2@mail.ru
        ];
    }

    get(query) {
        const randomApiKey = this.api_keys[Math.floor(Math.random() * this.api_keys.length)];
        const url = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';

        const options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Token ${randomApiKey}`,
            },
            body: JSON.stringify({query}),
        };

        return fetch(url, options)
            .then((response) => { return response.text(); })
            .then((result) => {
                return JSON.parse(result);
            })
            .catch((error) => { return {error}; });
    }
}
export default Dadata;
